export var resolveSpacingValues = function (spacing) { return "\n    ".concat(spacing.top, "px ").concat(spacing.right, "px ").concat(spacing.bottom, "px ").concat(spacing.left, "px;\n"); };
